module.exports = __webpack_public_path__ + "static/media/4Specialties.e922bc46.svg";